<template>
	<v-container
		fluid
		@contextmenu="showMenu"
		class="py-0 explorerwrapper"
		style="background-color:rgb(0,32,32);-webkit-box-align: inherit;align-items: inherit;height:100%;"
	>
		<!-- <v-row no-gutters>
			<v-col style="background-color:green">CRUMBS</v-col>
			<v-col style="background-color:red">MAINSPACE</v-col>
		</v-row> -->

		<v-row class="breadcrumb-wrapper">
			<div class="breadcrumbs scrollbar-3">
				<template v-for="(crumb,crumbindex,n) in breadcrumbs">
					<span
						v-if="crumbindex>0"
						style="padding-top:1px;"
						:key="'i-'+crumbindex"
					>
						<v-icon color="teal darken-1">mdi-chevron-right</v-icon>
					</span>
					<a
						@click="setActiveAsset(crumb._id)"
						:key="crumbindex"
					>{{crumb.name}}</a>
				</template>
			</div>
		</v-row>
		<v-row class="pt-1 explorer-workspace scrollbar-2">
			<div class="explorer-workspace-wrapper scrollbar-2">
				<!-- <transition name="scale-transition"> -->
				<div
					v-show="parentshortcut"
					class="explorer_asset backtoparent fx-scale"
					@click="openActiveAssetParent"
				>
					<v-icon>mdi-chevron-left</v-icon> <span>{{$store.getters.activeassetparentname}}</span>
				</div>
				<!-- </transition> -->
				<template v-if="$store.getters.activeassetsarray.length>0">
					<transition
						name="scale-transition"
						:key="assetid"
						v-for="(asset,assetid) in $store.getters.activeassets"
					>
						<div
							v-show="asset.visible"
							class="explorer_asset"
							@click="setActiveAsset(assetid)"
							@contextmenu.prevent.stop="showMenu($event,'edit',assetid)"
						>
							<v-icon>{{getIcon(asset)}}</v-icon><span>{{asset.name}}</span>
						</div>
					</transition>
				</template>
				<template v-else>
					<div>
						<!-- -- Add an Asset -- -->
					</div>
				</template>

				<!-- <v-row
				align="start"
				justify="start"
			>
				<v-col>
					
				</v-col>
			</v-row> -->
				<v-menu
					v-model="menu.visible"
					absolute
					offset-y
					style="max-width: 600px"
					:position-x="menu.x"
					:position-y="menu.y"
				>

					<v-list class="menulist">
						<template v-for="(item, index) in items">
							<v-subheader v-if="item.type==='assettypepicker' && $store.getters.assettypesarray.length > 0">{{item.title}}</v-subheader>
							<v-list
								v-if="item.type==='assettypepicker' && $store.getters.assettypesarray.length > 0"
								:key="index"
								class="menupicker scrollbar-2"
							>
								<v-list-item
									v-for="(assettype,assetindex) in $store.getters.assettypes"
									@click="launchMenuItem(index,{assettype:assettype._id,action:'quickAddAsset'})"
									:key="assetindex"
									class="menuitem"
								>
									<v-list-item-title>{{assettype.name}}</v-list-item-title>
								</v-list-item>
							</v-list>

							<v-list-item
								v-else-if="item.type!=='assettypepicker'"
								:key="index"
								@click="launchMenuItem(index)"
								class="menupickeritem menuitem"
							>
								<v-list-item-title>{{ item.title }}</v-list-item-title>
							</v-list-item>
						</template>

					</v-list>
				</v-menu>
				<v-dialog
					v-model="asseteditdlg"
					fullscreen
					hide-overlay
					transition="dialog-bottom-transition"
					class="tech-dialog"
				>
					<v-card class="tech-dialogpanel">
						<v-toolbar
							dark
							color="rgba(0,255,255,0.365)"
						>
							<v-btn
								icon
								dark
								@click="asseteditdlg = false"
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
							<v-toolbar-title>
								{{editmode === "edit"?"Edit":"Add New "}} {{edittype==='assettype'?"Asset Type":"Asset"}}
							</v-toolbar-title>
							<div class="flex-grow-1"></div>
							<v-toolbar-items>
								<v-btn
									dark
									text
									@click="saveAsset"
								>Save</v-btn>
							</v-toolbar-items>
						</v-toolbar>
						<v-card-text>
							<v-form>
								<!-- <div>Type: {{getTypeName(activeasset.type)}}</div> -->
								<div v-if="activeasset.type!=='assettype'">Parent: {{ getTypeName(activeasset.parent)}}</div>

								<v-select
									v-if="activeasset.type!=='assettype'"
									label="Type"
									v-model="activeasset.type"
									:items="$store.getters.assettypesarray"
									item-text="name"
									item-value="_id"
								>
									<template
										slot="item"
										slot-scope="data"
									>
										<v-icon>{{data.item.icon}}</v-icon> {{data.item.name}}
									</template></v-select>

								<v-text-field
									ref="assetdlgname"
									label="Name"
									color="primary"
									v-model="activeasset.name"
									@keyup.enter="saveAsset"
								></v-text-field>
								<v-text-field
									label="ID"
									v-model="activeasset._id"
									readonly
								></v-text-field>
								<v-text-field
									label="Ref"
									v-model="activeasset.ref"
									@input="refreshID"
								></v-text-field>
								<v-select
									v-if="activeasset.type==='assettype'"
									label="Of-Type"
									v-model="activeasset.parent"
									:items="$store.getters.assettypesarray"
									item-text="name"
									item-value="_id"
								></v-select>
								<v-select
									label="Icon"
									:append-outer-icon="activeasset.icon"
									v-model="activeasset.icon"
									:items="$store.state.iconlib"
									item-text="text"
									item-value="value"
								>
									<template
										slot="item"
										slot-scope="data"
									>
										<v-icon>{{data.item.value}}</v-icon> {{data.item.text}}
									</template></v-select>

								<v-spacer></v-spacer>
								<!-- <b>Additional Properties</b>
							<v-divider></v-divider>
							<template v-for="(prop,index) in activeasset.props">
								<v-row :key="index">
									<v-col>
										<v-text-field label="Name"></v-text-field>
									</v-col>
								</v-row>
							</template> -->
							</v-form>
						</v-card-text>
					</v-card>
				</v-dialog>
			</div>

		</v-row>
	</v-container>
</template>
<script>
import moment from "moment";
import shortid from "shortid";
import "@/lib/metaphone3.js";
let test = "Duncan";
console.warn(test, test.metaphone());
const ASSETTYPE = "assettype";
const IDPREFIX = "type_";

const asset_base = {
	_id: IDPREFIX,
	// _rev: "",
	ref: "",
	type: ASSETTYPE,
	status: "active",
	name: "",
	visible: true,
	description: "",
	date_created: moment().format("YYYY-MM-DD HH:mm:ss"),
	date_updated: moment().format("YYYY-MM-DD HH:mm:ss"),
	schema: {}
};

class Asset {
	constructor(params) {
		this.props = this.factory(params);
	}

	static factory(params) {
		let props = {
			_id: "A_",
			ref: "",
			type: "asset",
			status: "active",
			name: "",
			visible: true,
			description: "",
			date_created: moment().format("YYYY-MM-DD HH:mm:ss"),
			date_updated: moment().format("YYYY-MM-DD HH:mm:ss")
		};
		for (let i in params) {
			props[i] = params[i];
		}
		return props;
	}

	assign(params) {
		params = params || {};
		for (let i in params) {
			this.props[i] = params[i];
		}
	}
}
export default {
	created() {
		this.setActiveAsset("");
	},
	data() {
		return {
			selected: [],
			parentshortcut: false,
			editmode: "edit",
			edittype: "assettype",
			filtertext: "",
			asseteditdlg: false,
			activeasset: {},
			menu: {
				visible: false,
				x: 0,
				y: 0
			},
			items: [
				{
					title: "Add Asset Type",
					action: "openAssetTypeAdder",
					visible: true
				},
				{
					title: "Edit Asset",
					action: "openAssetEditor",
					visible: true
				},
				{
					title: "Delete Asset",
					action: "deleteAsset",
					visible: true
				},
				{
					title: "Create Asset:",
					type: "assettypepicker",
					visible: true
				}
				// { title: "Edit Asset" },
				// { title: "Run Asset" },
				// { title: "Browse Asset" }
			]
		};
	},
	computed: {
		breadcrumbs() {
			let items = [];
			let max = 10;
			let i = 0;
			const I = this;
			let doneroot = false;
			if (I.$store.state.activeasset) {
				let asset = I.$store.state.activeasset; //I.$store.state.assets[I.$store.state.activeasset];
				if (asset._id == "") {
					doneroot = true;
				}
				console.warn("Active asset: [" + asset.name + "]");
				console.warn(
					"Active asset Parent: [" + asset.parent + "]",
					asset
				);
				// while (asset._id !== "" && asset && i < max) {
				while (asset.parent && asset.parent !== "" && i < max) {
					console.warn("Asset", asset._id, asset.name, asset.parent);
					items.push({ name: asset.name, _id: asset._id });
					if (asset.parent && asset.parent !== "") {
						asset = I.$store.state.assets[asset.parent];
					}
					++i;
				}
				console.warn("Root Asset?", asset);
				items.push({ name: asset.name, _id: asset._id });
				//items.push({ name: "Root", id: "" });
			}
			if (!doneroot) {
				items.push({ name: "Root", _id: "" });
			}

			console.warn("Bread crumbs Items", items);
			items.reverse();
			return items;
		}
	},
	components: {},
	methods: {
		getIcon(asset) {
			const I = this;
			//$store.state.assets[asset.type].icon
			if (asset.icon) {
				return asset.icon;
			} else if (
				I.$store.state.assets[asset.type] &&
				I.$store.state.assets[asset.type].icon
			) {
				return I.$store.state.assets[asset.type].icon;
			} else {
				return "";
			}
		},
		openActiveAssetParent() {
			// Set active asset to the parent:

			this.setActiveAsset(this.$store.state.activeasset.parent);

			// if (
			// 	this.$store.state.assets[this.$store.state.activeasset.parent]
			// ) {
			// 	this.setActiveAsset(this.$store.state.activeasset.parent);
			// } else {
			// 	console.warn(
			// 		"No parent for active asset!",
			// 		this.$store.state.activeasset
			// 	);
			// }
		},
		setActiveAsset(assetid) {
			const I = this;
			console.warn("Setting active Asset:", assetid);
			// Hide assets:
			// let assets = I.$store.getters.hiddenactiveassets;
			// console.warn(">>HIDING Active assets:", assets);
			// for (let assetid in assets) {
			// 	console.warn("Asset:", assetid, assets[assetid]);
			// 	assets[assetid].visible = false;
			// }
			this.parentshortcut = false;
			I.$store.commit("hideActiveAssetChildren");

			setTimeout(function() {
				I.$store.commit("setActiveAsset", {
					_id: assetid,
					hideassets: true
				});
				console.warn(
					"Parent?",
					I.$store.state.assets[I.$store.state.activeasset.parent]
				);
				if (assetid !== "") {
					I.parentshortcut = true;
				}
				// if (I.$store.state.assets[I.$store.state.activeasset.parent]) {
				// 	I.parentshortcut = true;
				// 	console.warn("YES!");
				// }

				I.$store.commit("showActiveAssetChildren");
				// let assets = I.$store.getters.hiddenactiveassets;
				// console.warn(">>REVEALING Active assets:", assets);
				// for (let assetid in assets) {
				// 	assets[assetid].visible = true;
				// }
			}, 100);
		},
		getTypeName(assetid) {
			let asset = this.$store.state.assets[assetid];
			if (asset) {
				return asset.name;
			} else {
				return "??";
			}
			// return this.$store.state.assets[assetid].name;
		},
		refreshID() {
			const I = this;
			let meta = I.activeasset.ref.metaphone();
			console.warn(meta);
			meta = meta.join("");
			// I.activeasset._id = IDPREFIX + I.activeasset.ref.metaphone()[0];
			I.activeasset._id = IDPREFIX + meta;
		},
		resetAsset(params) {
			const I = this;
			I.activeasset = Asset.factory(params); //JSON.parse(JSON.stringify(asset_base));
			I.activeasset.ref = shortid.generate();
			I.activeasset._id = IDPREFIX + I.activeasset.ref;
			if (I.$store.state.assets[I.activeasset.type]) {
				I.activeasset.icon =
					I.$store.state.assets[I.activeasset.type].icon;
			}
		},
		launchMenuItem(menuindex, params) {
			const I = this;
			params = params || {};

			let menuitem = this.items[menuindex];
			let action = menuitem.action;
			params.pouch = I.$pouch;
			if (params.action) {
				action = params.action;
			}
			if (action) {
				switch (action) {
					case "openAssetTypeAdder":
						// I.openAddItemDialog();
						I.openAddAssetTypeDialog();
						break;
					case "openAssetAdder":
						I.openAddAssetDialog(params);
						break;
					case "openAssetEditor":
						I.openEditAssetDialog(params);
						break;
					case "quickAddAsset":
						I.quickAddAsset(params);
						break;
					case "deleteAsset":
						I.deleteAsset(params);
						break;
				}
			}
			console.warn("Menu was clicked", menuitem);
		},

		deleteAsset(params) {
			const I = this;
			params = params || {};
			console.warn("DELETEING!!!", I.selected);
			if (I.selected.length > 0) {
				//I.activeasset = I.$store.state.assets[I.selected[0]];
				params.assetid = I.selected[0];
				I.$store.commit("deleteAsset", params);
				// delete I.$store.state.assets[I.selected[0]];
				I.selected = [];
			}
		},

		openEditAssetDialog(params) {
			const I = this;
			params = params || {};
			if (I.selected.length > 0) {
				I.activeasset = I.$store.state.assets[I.selected[0]];
			}
			// I.activeasset = params.activeasset;
			// params.assettype = params.assettype || "asset";
			// I.resetAsset({
			// 	type: params.assettype,
			// 	parent: I.$store.state.activeasset._id
			// });
			I.asseteditdlg = true;
			I.editmode = "edit";
			I.edittype = "asset";
			setTimeout(() => {
				this.$refs.assetdlgname.focus();
			}, 100);
		},

		quickAddAsset(params) {
			const I = this;
			params = params || {};
			params.assettype = params.assettype || "asset";
			I.resetAsset({
				name: "New " + I.$store.state.assets[params.assettype].name,
				type: params.assettype,
				parent: I.$store.state.activeasset._id
			});
			I.$store.commit("addAsset", {
				asset: I.activeasset,
				pouch: I.$pouch
			});
		},
		openAddAssetDialog(params) {
			const I = this;
			params = params || {};
			params.assettype = params.assettype || "asset";
			I.resetAsset({
				type: params.assettype,
				parent: I.$store.state.activeasset._id
			});
			I.asseteditdlg = true;
			I.editmode = "add";
			I.edittype = "asset";
			setTimeout(() => {
				this.$refs.assetdlgname.focus();
			}, 100);
		},

		openAddAssetTypeDialog() {
			const I = this;
			I.resetAsset({ type: "assettype" });
			I.asseteditdlg = true;
			I.editmode = "add";
			I.edittype = "assettype";
			setTimeout(() => {
				this.$refs.assetdlgname.focus();
			}, 100);
		},

		openAddItemDialog() {
			const I = this;
			I.resetAsset();
			I.asseteditdlg = true;
			I.editmode = "add";
			setTimeout(() => {
				console.warn("REFS", this.$refs);
				this.$refs.assetdlgname.focus();
			}, 100);
		},
		saveAsset() {
			const I = this;
			if (I.editmode === "edit") {
				I.$store.commit("putAsset", {
					asset: I.activeasset,
					pouch: I.$pouch
				});
			} else {
				I.$store.commit("addAsset", {
					asset: I.activeasset,
					pouch: I.$pouch
				});
			}

			I.asseteditdlg = false;
		},
		selectAsset(assetid) {
			this.selected = [assetid];
		},
		selectNoAsset() {
			this.selected = [];
		},
		showMenu(event, mode, assetid) {
			console.warn("SHOW MENU", event, mode);
			console.warn(event.target);
			if (assetid) {
				if (mode === "edit") {
					this.selectAsset(assetid);
				}
			} else {
				this.selectNoAsset();
			}
			this.menu.visible = true;
			this.setMenu(event.x, event.y);
			event.preventDefault();
			event.stopPropagation();
		},

		hideMenu() {
			this.menu.visible = false;
		},

		setMenu(x, y) {
			this.menu.x = x;
			this.menu.y = y;
		}
	}
};
</script>
<style>
.explorerwrapper {
	display: flex;
	flex-flow: column wrap;
	position: relative;
}
.breadcrumb-wrapper {
	flex: 0 1 2rem;
	position: relative;
	height: 2rem;
}
.explorer-workspace-wrapper {
	display: flex;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	flex-flow: row wrap;
	height: 100%;
	width: 100%;
	overflow: auto;
	align-content: flex-start;
}
.explorer-workspace {
	flex: 1 0 auto;
	position: relative;
}
.explorer_asset {
	position: relative;
	user-select: none;
	border: 1px outset rgb(0, 200, 200);
	background: rgba(0, 110, 172, 0.5);
	padding: 0.4rem;
	margin: 0.3rem;
	width: 30vw;
	height: 7rem;
	border-radius: 5px;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;
	font-size: 0.8rem;
	display: flex;
	align-items: flex-end;
	justify-content: center;
}
.explorer_asset:hover {
	background: rgba(0, 128, 128, 0.8);
}
.explorer_asset span {
	text-shadow: 1px 1px 1px rgba(0, 100, 100, 0.3);
	position: relative;
}
.explorer_asset:hover span {
	text-shadow: 0px 0px 2px white;
}
.backtoparent {
	background: rgba(0, 96, 96, 0.5);
}
.explorer_asset .v-icon {
	text-shadow: 1px 1px 1px rgba(0, 100, 100, 0.3);
	position: absolute;
	left: 50%;
	top: 40%;
	color: rgba(0, 0, 0, 0.3);
	transform: translateX(-50%) translateY(-50%);
	font-size: 6rem;
}

.explorer_asset.backtoparent .v-icon {
	position: absolute;
	left: 50%;
	top: 50%;
	color: rgba(0, 0, 0, 0.3);
	transform: translateX(-50%) translateY(-50%);
	font-size: 10rem;
}

.menupicker {
	max-height: 10rem;
	overflow: auto;
	border: 1px inset #333;
	background-image: linear-gradient(#333, teal, #333) !important;
}
.menupickeritem {
	color: white;
	text-shadow: 0px 0px 5px white;
}
.breadcrumbs {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: 2rem;
	width: 100%;
	display: flex;
	flex: row nowrap;
	overflow-x: scroll;
	user-select: none;
	/* border-bottom: 1px solid green; */
	/* background-color: rgb(0, 32, 32); */
	background-image: linear-gradient(
		rgb(0, 96, 96),
		rgb(0, 32, 32),
		rgb(0, 56, 56),
		rgb(0, 32, 32),
		rgb(0, 64, 64),
		rgb(0, 96, 96)
	) !important;

	white-space: nowrap;
}
.breadcrumbs a {
	position: relative;
	white-space: nowrap;
	padding: 0.2rem 0.5rem;
	color: darkturquoise !important;
}
.breadcrumbs a:last-child {
	text-shadow: 0px 0px 10px rgb(200, 200, 200);
}

.breadcrumbs a:hover {
	color: white !important;
}
</style>
